import PropTypes from 'prop-types';

export default {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]).isRequired,
    title: PropTypes.string.isRequired,
};
